// Ações do card de download ("Tentar de novo", "Cancelar"). São funções, então ficam fora do
// Redux; o card as encontra pelo `id` do download atual. Um download por vez, como no slice.
export interface FileDownloadControls {
  retry?: () => void,
  cancel?: () => void,
}

let current: { id: string, controls: FileDownloadControls } | null = null;

export function setFileDownloadControls(id: string, controls: FileDownloadControls) {
  current = { id, controls };
}

export function getFileDownloadControls(id: string): FileDownloadControls {
  return current?.id === id ? current.controls : {};
}
